import { render, staticRenderFns } from "./StudentAttendanceDetails.vue?vue&type=template&id=5ebbf48d"
import script from "./StudentAttendanceDetails.vue?vue&type=script&lang=js"
export * from "./StudentAttendanceDetails.vue?vue&type=script&lang=js"
import style0 from "./StudentAttendanceDetails.vue?vue&type=style&index=0&id=5ebbf48d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports